 <!-- Documentation -->
 <div class="cd-section" id="features" style="background-color: white;">
   <div class="container-fluid mb-3">
     <div class="row">

       <!-- Navigation Panels -->
       <div class="col-md-3">
         <div id="accordion" role="tablist">
           <div class="card card-collapse">
             <div class="card-header" role="tab" id="headingOne">
               <h5 class="mb-0">
                 <a data-toggle="collapse" class="ml-2 docNav" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Installation & Upgrades
                   <i class="material-icons">keyboard_arrow_down</i>
                 </a>
               </h5>
             </div>

             <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne"
               data-parent="#accordion">
               <div class="card-body">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/overview']">Overview</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/prerequisites']">Pre-Requisites</a></li>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/certificates']">DNS, Certificates, and SSL</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/license']">Licensing</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/ports']">Ports and Protocols</a></li>
                    </ul>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/installation']">Installation Options</a></li>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/standalone']">Stand-Alone</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/kubernetes']">Kubernetes</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/windows-iis']">Windows with IIS</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/appliance']">Appliance</a></li>
                    </ul>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/sizing']">Sizing</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/upgrades']">Upgrades</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/monitoring']">Monitoring</a></li>
                  </ul>
               </div>
             </div>
           </div>
           <div class="card card-collapse">
            <div class="card-header" role="tab" id="headingSix">
              <h5 class="mb-0">
                <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false"
                  aria-controls="collapseSix">
                  Configuration
                  <i class="material-icons">keyboard_arrow_down</i>
                </a>
              </h5>
            </div>
            <div id="collapseSix" class="collapse" role="tabpanel" aria-labelledby="headingSix"
              data-parent="#accordion">
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/security']">Security</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/tenant']">Multi-Tenant</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/sqlserver']">SQL Server</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/email']">Email Configuration</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/users']">User Management and Roles</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/custom-fields']">Custom Fields</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/meta-data']">Meta-Data</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/catalogues']">Catalogues</a></li>
                    <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/options']">Optional Integrations</a></li>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/ad-ldap']">AD/LDAP Configuration</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/ad-sso']">Azure AD/SSO</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/slack']">Slack Integration</a></li>
                      <li class="list-group-item" style="padding-left: 50px;"><a class="docLink" [routerLink]="['/documentation/msteams']">Microsoft Teams Integration</a></li>
                    </ul>
                </ul>
              </div>
            </div>
          </div>
           <div class="card card-collapse">
             <div class="card-header" role="tab" id="headingTwo">
               <h5 class="mb-0">
                 <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                   aria-controls="collapseTwo">
                   Modules
                   <i class="material-icons">keyboard_arrow_down</i>
                 </a>
               </h5>
             </div>
             <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo"
               data-parent="#accordion">
               <div class="card-body">
                <ul class="list-group list-group-flush" *ngFor="let m of modules">
                  <li class="list-group-item"><a class="docLink" [routerLink]="[m.link]">{{ m.title }}</a></li>
                </ul>
               </div>
             </div>
           </div>
           <div class="card card-collapse">
             <div class="card-header" role="tab" id="headingThree">
               <h5 class="mb-0">
                 <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                   aria-controls="collapseThree">
                   Features
                   <i class="material-icons">keyboard_arrow_down</i>
                 </a>
               </h5>
             </div>
             <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree"
               data-parent="#accordion">
               <div class="card-body">
                <ul class="list-group list-group-flush" *ngFor="let m of features">
                  <li class="list-group-item"><a class="docLink" [routerLink]="[m.link]">{{ m.title }}</a></li>
                </ul>
               </div>
             </div>
           </div>
           <div class="card card-collapse">
             <div class="card-header" role="tab" id="headingFour">
               <h5 class="mb-0">
                 <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false"
                   aria-controls="collapseFour">
                   Best Practices & Guides
                   <i class="material-icons">keyboard_arrow_down</i>
                 </a>
               </h5>
             </div>
             <div id="collapseFour" class="collapse" role="tabpanel" aria-labelledby="headingFour"
               data-parent="#accordion">
               <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/guide-building-security-plans']">Building Security Plans and Conducting Assessments</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/guide-rmf']">Implementing the Risk Management Framework (RMF)</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/info-hierarchy']">Understanding the RegScale Information Architecture</a></li>
                </ul>
               </div>
             </div>
           </div>
           <div class="card card-collapse">
            <div class="card-header" role="tab" id="headingFive">
              <h5 class="mb-0">
                <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false"
                  aria-controls="collapseFive">
                  APIs
                  <i class="material-icons">keyboard_arrow_down</i>
                </a>
              </h5>
            </div>
            <div id="collapseFive" class="collapse" role="tabpanel" aria-labelledby="headingFive"
              data-parent="#accordion">
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/apis']">Getting Started</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/apis-authentication']">Authentication</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/apis-create']">Create a New Record</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/apis-get']">Retrieve Records</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card card-collapse">
            <div class="card-header" role="tab" id="headingSeven">
              <h5 class="mb-0">
                <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                  aria-controls="collapseSeven">
                  Command Line Interface (CLI) 
                  <i class="material-icons">keyboard_arrow_down</i>
                </a>
              </h5>
            </div>
            <div id="collapseSeven" class="collapse" role="tabpanel" aria-labelledby="headingSeven"
              data-parent="#accordion">
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-overview']">Overview and Configuration</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-cronjob']">Orchestration and Scheduling</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-docker']">Running in a Docker Container</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-ad']">Active Directory (AD)</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-cisa']">DHS CISA</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-encrypt']">Encrypt/Decrypt</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-evidence']">Evidence</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-healthcheck']">Health Check</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-jira']">Jira</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-login']">Login</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-defender']">Microsoft 365 Defender</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-migrations']">Migrations</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-oscal']">NIST OSCAL</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-reminder']">Reminder</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-snow']">ServiceNow</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-tenable']">Tenable</a></li>
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/cli-wiz']">Wiz.io</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card card-collapse">
            <div class="card-header" role="tab" id="headingSeven">
              <h5 class="mb-0">
                <a class="collapsed ml-2 docNav" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false"
                  aria-controls="collapseSeven">
                  Support
                  <i class="material-icons">keyboard_arrow_down</i>
                </a>
              </h5>
            </div>
            <div id="collapseEight" class="collapse" role="tabpanel" aria-labelledby="headingEight"
              data-parent="#accordion">
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><a class="docLink" [routerLink]="['/documentation/support']">Opening Tickets</a></li>
                </ul>
              </div>
            </div>
          </div>
         </div>
       </div>

       <!-- Knowledge Base Articles-->
       <div class="col-md-9">
         <div class="card">
           <div class="card-content">
             <div class="card-body documentation">
               <markdown ngPreserveWhitespaces [src]="strSource"></markdown>
             </div>
           </div>
         </div>
       </div>

     </div>
   </div>
 </div>

 <!-- Contact Us -->
 <app-contact-us></app-contact-us>
